import React from 'react';
import { useCurrentProvider } from '../../../Components/Permissions';
import { UnexpectedError } from '../../Shared';
import { StudentList } from '../StudentList';

export const StudentsTab = () => {
  const { currentProvider } = useCurrentProvider();
  const organizationId = currentProvider.organizations[0]?.id;

  if (organizationId === undefined) {
    // Unreachable through routing — /beacon is gated on useShowBeaconNavItem, which already
    // requires organizations[0]. Kept as a defensive guard; a missing org is not retryable.
    return <UnexpectedError message="No organization is available for this account." cannotRetry />;
  }

  return <StudentList organizationId={organizationId} />;
};
